import React, {Fragment} from 'react'
import Link from '@salesforce/retail-react-app/app/components/link'
import {Box} from '@salesforce/retail-react-app/app/components/shared/ui'
import PropTypes from 'prop-types'
import {blogRoute} from '../../utills/url'

const TagsLink = ({tags, data}) => {
    if (!data.c_tags) return
    return (
        <Box as="p" textAlign={'right'}>
            {tags && <b>Tags: </b>}
            {data &&
                data.c_tags &&
                data.c_tags.map((link, index) => {
                    return (
                        <Fragment key={index}>
                            <Link to={blogRoute(link.id)}>{link.displayName}</Link>
                            {index < data.c_tags.length - 1 && ', '}
                        </Fragment>
                    )
                })}
        </Box>
    )
}

TagsLink.propTypes = {
    tags: PropTypes.bool,
    data: PropTypes.shape({
        c_tags: PropTypes.arrayOf(
            PropTypes.shape({
                id: PropTypes.string,
                displayName: PropTypes.string
            })
        )
    })
}
export default TagsLink
